'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
let app = window.app;
class Link extends _react.PureComponent {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const is_link = props.href ? true : false;
    let output;
    if (is_link && props.href !== document.location.pathname) {
      output = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, _extends({
        to: props.href,
        className: props.className,
        onClick: app.resetFunctions
      }, props), props.children);
    } else {
      output = /*#__PURE__*/_react.default.createElement("span", _extends({
        className: props.className
      }, props), props.children);
    }
    return output;
  }
}
exports.default = Link;
